import deliveryZoneColorMap from '../../core/constants/deliveryZoneColorMap';
import { Color } from '../../core/enums/Color';
import { BarrierDeviceMode, BarrierLocation } from '../../core/state/barriers/types';
import Badge from '../components/badge/Badge';

export const getBarrierModeColor = (mode: BarrierDeviceMode | undefined) => {
  switch (mode) {
    case BarrierDeviceMode.Online:
      return Color.Green;
    case BarrierDeviceMode.Offline:
      return Color.Red;
    case BarrierDeviceMode.ServiceMode:
      return Color.Grey;
    default:
      return Color.Green;
  }
};

export const getDeliveryZonesBadges = (locations: BarrierLocation[]) => (
  <div className="d-flex">
    {locations.map((item) => (
      <div className="mr-1">
        <Badge
          tooltip={item.deliveryZoneName}
          key={item.deliveryZoneIndex}
          color={deliveryZoneColorMap[item.deliveryZoneIndex]}
          icon={item.deliveryZoneIndex}
        />
      </div>
    ))}
  </div>
);
